<template>
  <div>
    <Header :pageName='"home"'></Header>
    <section class="login-content">
        <div class="content">
            <div class="login-main">
                <ul class="login-nav">
                    <li :class="isChildLogin?'':'active'" @click="isChildLogin=!isChildLogin">Main account</li>
                    <li :class="!isChildLogin?'':'active'" @click="isChildLogin=!isChildLogin">Sub account</li>
                </ul>
								<!--<div class="login-error" v-if="errorMsg">
									{{errorMsg}}
								</div>-->
                <div class="login-box" v-if="!isChildLogin">
                	<div class="login-error" v-if="errorMsg">
									{{errorMsg}}
								  </div>
                    <div class="login-item" >
                        <input class="login-input"  v-model="userName"  type="text" @keyup.enter="submit" placeholder="User name" maxlength="10" />
                        <label class="plh-style">User name</label>
                    </div>

                    <div class="login-item">
                        <input class="login-input"  v-model="password" type="password" @keyup.enter="submit" placeholder="Password" maxlength="30">
                    </div>
                    <div class="login-item">
                        <input class="code-input"  v-model="code" type="text" @keyup.enter="submit" placeholder="Captcha" maxlength="4">
                        <div class="code" v-if="!islodingCode" @click="getCheckCode"><img v-if="codeInfo.Img" :src="'data:image/jpg;base64,'+codeInfo.Img" alt="Captcha"></div>
                        <div class="code" v-if="islodingCode" ><img v-if="codeInfo.Img" :src="'data:image/jpg;base64,'+codeInfo.Img" alt="Captcha"></div>
                    </div>
                    <div class="login-btn" v-if="!isloding" @click="submit()">Log&nbsp;&nbsp;in</div>
                    <div class="login-btn" v-if="isloding">Logging&nbsp;&nbsp;in</div>
                    <!-- <label for="rememberPassword"><input id="rememberPassword" type="checkbox" >记住登录</label> -->
                </div>

                <div  class="login-box" v-if="isChildLogin">
                    <div class="login-error" v-if="errorMsg">
                  {{errorMsg}}
                  </div>
                    <div class="login-item">
                        <input class="login-input"  v-model="userNameChild" type="text" @keyup.enter="submit" placeholder="User name" maxlength="10">
                    </div>

                    <div class="login-item">
                        <input class="login-input"  v-model="Oper" type="text" @keyup.enter="submit" placeholder="Child account" maxlength="10">
                    </div>

                    <div class="login-item">
                        <input class="login-input"  v-model="passwordChild" type="password" @keyup.enter="submit" placeholder="Password" maxlength="30">
                    </div>

                    <div class="login-item">
                        <input class="code-input"  v-model="codeChild" type="text"  @keyup.enter="submit" placeholder="Captcha" maxlength="4">
                        <div class="code" v-if="!islodingCode" @click="getCheckCode">
                          <img v-if="codeInfo.Img" :src="'data:image/jpg;base64,'+codeInfo.Img" alt="Captcha">
                        </div>
                        <div class="code" v-if="islodingCode">
                          <img v-if="codeInfo.Img" :src="'data:image/jpg;base64,'+codeInfo.Img" alt="Captcha">
                        </div>
                    </div>

                    <div class="login-btn" v-if="!isloding" @click="submit()">Log&nbsp;&nbsp;in</div>
                    <div class="login-btn" v-if="isloding">登录中</div>
                    <!-- <label for="rememberPassword2"><input id="rememberPassword2" type="checkbox">记住密码</label> -->
                </div>
                <label for="rememberPassword" class="remember-log"><input id="rememberPassword" type="checkbox" v-model="rememberLog" >Automatic login within seven days</label>
            </div>
        </div>
    </section>
    <section class="info-content">
        <div class="content">
            <div class="info-main">
                <div class="info-icon"><img src="./../assets/images/info-main.png" alt=""></div>
                <!-- <div class="info-box">
                    <div class="info-icon"><img src="./../assets/images/info-icon-1.png" alt=""></div>
                    <div class="info-title">操作简单</div>
                    <p class="info-desc">控房控价，处理订单，操作简单。<br>PC端、移动端同步</p>
                </div>
                <div class="info-box">
                    <div class="info-icon"><img src="./../assets/images/info-icon-2.png" alt=""></div>
                    <div class="info-title">渠道畅通</div>
                    <p class="info-desc">酒店资源进入“控房易”，平台2W余家<br>优质旅行社即刻找到您！，大大提高产量</p>
                </div>
                <div class="info-box">
                    <div class="info-icon"><img src="./../assets/images/info-icon-3.png" alt=""></div>
                    <div class="info-title">免费注册</div>
                    <p class="info-desc">点击<a href="javascriptvoid(0)">加盟合作</a>提交资料，或者直接<br>致电我们，直接开通！</p>
                </div> -->
            </div>
        </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./../common/header/header.vue"
import Footer from "./../common/footer/footer.vue"
export default {
  name: 'login',
  components:{
    Header,
		Footer
  	},

  data () {
    return {
      userName: '',
      userNameChild: '',
      password: '',
      passwordChild: '',
      Oper: '',
      codeInfo:'',
      code:'',
      errorMsg:'',
      codeChild:'',
      isChildLogin:false,
      rememberLog:this.dao.get('rememberLog')=='true'?true:false,
      isloding:false,
      islodingCode:false,
      plhShow1:false,
      plhShow2:false,
      plhShow3:false,
      plhShow4:false,
    }
  },
  methods: {
    getCheckCode(){
      var that=this;
      that.islodingCode=true;
      that.getRequest({
          url: that.Api.getCheckCode
      }).then(res => {
          that.islodingCode=false;
          if (res) {
             
              that.codeInfo=res;
          } else {
              that.errorMsg='验证码获取失败，请重新获取';
          }
      });
    },
    submit () {

      var that=this;
      var params={};
      if(!that.isChildLogin){
          if (!that.userName){
              that.errorMsg='请输入用户名';
              return;
          }
          if (!that.password){
              that.errorMsg='请输入密码';
              return;
          }
          if (!that.code){
              that.errorMsg='请输入验证码';
              return;
          }
          params={
            userName: that.userName,
            password: that.password,
            grant_type:'password',
            CT:that.codeInfo.Token,
            CTK:that.codeInfo.TraceKey,
            CC:that.code

          }
          that.dao.set('loginAsChild','false');
      }else{
          if (!that.userNameChild){
              that.errorMsg='请输入用户名';
              return;

          }
          if (!that.Oper){
              that.errorMsg='请输入操作员';
              return;

          }
          if (!that.passwordChild){
              that.errorMsg='请输入密码';
              return;

          }  
          if (!that.codeChild){
              that.errorMsg='请输入验证码';
              return;
          }   
          
          params={
            userName: that.userNameChild,
            password: that.passwordChild,
            Oper:that.Oper,
            grant_type:'password',
            CT:that.codeInfo.Token,
            CTK:that.codeInfo.TraceKey,
            CC:that.codeChild
          }
          that.dao.set('loginAsChild','true');

      }
      if(this.rememberLog){
        that.dao.set('rememberLog','true');
      }else{
        that.dao.set('rememberLog','false');
      }   
     
     
      that.isloding=true;
      that.postRequest({
          url: that.Api.login,
          params: params
      }).then(res => {
          that.isloding=false;
      
          if (res&&res.userName||res.LoginedOn) {
              that.setHttpHeaders(res.access_token);
            
              if(res.Permissions&&res.Permissions.indexOf(1)<=-1&&res.Permissions.indexOf(2)<=-1&&res.Permissions.indexOf(3)<=-1&&res.Permissions.indexOf(5)<=-1&&res.Permissions.indexOf(7)<=-1){
                that.errorMsg='该用户没有任何权限！请联系主帐号';
                return;
              }
              var res=JSON.stringify(res);
              that.errorMsg='';
              that.dao.set('res',res);
              that.$router.push('/index');
          } else {
            // console.log(res);
            that.errorMsg=res.error_description?res.error_description:'登录错误，请重新登录';
            that.getCheckCode();
              
          }
      });
    }
  },
  mounted(){
  
    this.getCheckCode();
  
    var res=JSON.parse(this.dao.get('res'));
    var rememberLog=this.dao.get('rememberLog');

    
  
    if(res&&rememberLog=='true'){
      this.setHttpHeaders(res.access_token);
      this.$router.push('/index');
    }
    if(rememberLog=='false'){
        localStorage.clear(); 
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue